

import { API_CENTRE } from "../config";
import _o2sService from "../_o2sServices";
import { IFilter } from "../../models/filters/filter";
import { IPSLotFilter } from "../../models/filters/sanitaire/psLotFilter";
import { IPSLotForm } from "../../models/forms/sanitaire/psLotForm";
import { IPSLotPDTO } from "../../models/dtos/sanitaire/psLotPDTO";

export default class PSLotService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/PSLot";

    protected static override  getUrlFilter<F extends IPSLotFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.code != undefined)
                url += `&Code=${filter.code}`;
        }

        return url;
    }

    public static override toDTO(obj:IPSLotForm):IPSLotPDTO {
        const dto = super.toDTO(obj) as IPSLotPDTO;
        return dto;
    }
}
